/**
 * Hình biểu tượng ngành — MỘT nguồn cho Mini App (`BieuTuongNganh` ở apps/miniapp/src/app.tsx) và web quầy (khung xem trước
 * ở Cấu hình → Thông tin tiệm). Nét đơn, lưới 24×24; khoá = `NGANH[n].bieuTuong` trong `nganh.ts`. v0.23.0, ADR-115.
 *
 * Số liệu chép NGUYÊN VĂN từ bản JSX cũ của Mini App (thứ tự phần = thứ tự vẽ): hình phải trùng từng điểm ảnh với trước khi
 * gộp — `node scripts/kiem-mini-dat-lich.mjs` G1 + ảnh chụp trước / sau. Tệp chạy được trong trình duyệt và Mini App (es2015):
 * chỉ import kiểu từ `./nganh.ts`, không bigint.
 */
import type { BieuTuongNganh } from './nganh.ts'

export type PhanHinh =
  | { k: 'path'; d: string }
  | { k: 'circle'; cx: number; cy: number; r: number }
  | { k: 'rect'; x: number; y: number; width: number; height: number; rx?: number }

/** Khoá React ổn định cho một phần hình (không dùng chỉ số mảng). */
export function khoaPhanHinh(p: PhanHinh): string {
  if (p.k === 'path') return `p${p.d}`
  if (p.k === 'circle') return `c${p.cx}/${p.cy}`
  return `r${p.x}/${p.y}`
}

export const HINH_NGANH: Record<BieuTuongNganh, readonly PhanHinh[]> = {
  keo: [
    { k: 'circle', cx: 6, cy: 6, r: 3 },
    { k: 'circle', cx: 6, cy: 18, r: 3 },
    { k: 'path', d: 'M20 4 8.1 15.9M14.5 14.5 20 20M8.1 8.1 12 12' },
  ],
  'lo-son': [
    { k: 'path', d: 'M9 3h6v5H9zM8 8h8l1 13H7z' },
    { k: 'path', d: 'M10 12h4' },
  ],
  'giot-nuoc': [
    { k: 'path', d: 'M12 21c-4-2.5-7-6-7-10a7 7 0 0 1 14 0c0 4-3 7.5-7 10Z' },
    { k: 'path', d: 'M12 7v8M9 11h6' },
  ],
  'to-lich': [
    { k: 'rect', x: 4, y: 5, width: 16, height: 15, rx: 2 },
    { k: 'path', d: 'M8 3v4M16 3v4M4 10h16M8 14h3' },
  ],
  'la-sen': [
    {
      k: 'path',
      d: 'M12 3c2.6 2.9 3.9 5.8 3.9 8.7S14.6 17 12 19c-2.6-2-3.9-4.4-3.9-7.3S9.4 5.9 12 3Z',
    },
    {
      k: 'path',
      d: 'M4 10c3 .3 5.3 1.7 6.8 3.9M20 10c-3 .3-5.3 1.7-6.8 3.9M4 10c0 5 3 8.7 8 9 5-.3 8-4 8-9',
    },
  ],
  'ban-chan': [
    { k: 'circle', cx: 6, cy: 10, r: 1.8 },
    { k: 'circle', cx: 9.5, cy: 6, r: 1.8 },
    { k: 'circle', cx: 14.5, cy: 6, r: 1.8 },
    { k: 'circle', cx: 18, cy: 10, r: 1.8 },
    { k: 'path', d: 'M8 17c0-3 2-5.5 4.5-5.5S17 14 17 17c0 2-1.5 3-3 3h-3c-1.5 0-3-1-3-3Z' },
  ],
  'may-anh': [
    {
      k: 'path',
      d: 'M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z',
    },
    { k: 'circle', cx: 12, cy: 13, r: 3.5 },
  ],
  'o-to': [
    { k: 'path', d: 'M5 15l1.5-5h11L19 15' },
    { k: 'rect', x: 3, y: 15, width: 18, height: 4, rx: 1 },
    {
      k: 'path',
      d: 'M7 19v1.5M17 19v1.5M12 3.5c1 1.3 1.6 2.3 1.6 3.1a1.6 1.6 0 0 1-3.2 0c0-.8.6-1.8 1.6-3.1Z',
    },
  ],
}
